import { Popover, MenuItem, FormControl, Select, Box } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function LanguageSelectorModal({ anchorEl, onClose }) {
  const { i18n } = useTranslation();
  const open = Boolean(anchorEl);
  const [language, setLanguage] = useState(i18n.language);
  const languageList = i18n.options.resources;

  const handleLanguageChange = (event) => {
    const lang = event.target.value;
    setLanguage(lang);
    i18n.changeLanguage(lang);
    window.localStorage.setItem("languageSet", lang);
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
          p: 1.5,
          borderRadius: 2,
          width: 180,
        },
      }}
    >
      <Box>
        <FormControl fullWidth size="small">
          <Select value={language} onChange={handleLanguageChange}>
            {Object.keys(languageList).map((l) => (
              <MenuItem key={l} value={l}>
                {languageList[l].name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Popover>
  );
}
